import React, {Component} from 'react';
import OrderRow from './orderRow';

class Equivalent extends Component {
  render() {
    const {equivalences} = this.props;

    if (typeof equivalences === 'undefined' || !equivalences.length) {
      return null;
    }

    return equivalences.map((equivalence, index) => {
      return (<OrderRow key={index} type='equivalent' order={equivalence} />);
    });
  }
}

export default Equivalent;
